import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/authSlice';
import dispatchReducer from './slices/dispatchSlice';
import invoiceReducer from './slices/invoiceSlice';
import paymentReducer from './slices/paymentSlice';
import brokerReducer from './slices/brokerSlice';

// Import reducers here as you create them
// import authReducer from './slices/authSlice';

// Create a root reducer that can handle clearing all stores
const appReducer = combineReducers({
  auth: authReducer,
  dispatch: dispatchReducer,
  invoices: invoiceReducer,
  payments: paymentReducer,
  brokers: brokerReducer
});

// Root reducer that can clear all state
const rootReducer = (state: any, action: any) => {
  // When logout action is dispatched, reset all state to initial
  if (action.type === 'auth/logout/fulfilled') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector; 